//DB WRITE PASSIERT AUF EBENE MeldungSongGeAdded.js

import React, { useState, useEffect, useCallback } from 'react';
import "../Faq.css";
// import FeedbackCarousel from "./FeedbackCarousel/FeedbackCarousel";

import { useStateValue } from "../StateProvider";
// import Timer from "./Timer";
// import SongRow from "./SongRow";
// import PlayCircleFilledIcon from "@material-ui/icons/PlayCircleFilled";
// import FavoriteIcon from "@material-ui/icons/Favorite";
// import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
// import { testTrackThree } from "./testtrack";


// import { AlternateEmail } from "@material-ui/icons";
// import TrackResult from "./TrackResult";
//import SearchResults from "./jammming-src/Components/SearchResults/SearchResults";
//import TrackList from "./jammming-src/Components/TrackList/TrackList";
//import Track from "./jammming-src/Components/Track/Track";

// war auf 3
const timeUntilNoMoreChecks=3;

function MeldungSongGeAddedBody() {
const [{NameOfAddedSong, showButtonBackToCarousel, slideNrToShowToUser, isLimitedSongsUpload}, dispatch] = useStateValue();
const [counter, setCounter] = useState(timeUntilNoMoreChecks);

// Check if this was a limited songs upload (subsequent upload with few or no songs)
// If true, show "No more songs to rate" message instead of redirecting to carousel
const shouldShowNoMoreSongs = isLimitedSongsUpload;

const handleLogout = () => {
    // Clear the Spotify token to log the user out
    dispatch({
      type: "SET_TOKEN",
      token: null,
    });

    // Clear user info
    dispatch({
      type: "SET_USER",
      user: null,
    });

    // Clear user startseite
    dispatch({
      type: "SET_USERSTARTSEITE",
      userstartseite: {"id" : "nochnicht"},
    });

    // Clear session storage
    sessionStorage.clear();

    // Redirect to home
    window.location.href = '/';
  };

const backToCarousel = useCallback(() => {




    //CHEATCHECK SONG ZU AUSGANGSLAGE START


          dispatch({
            type: "SET_INFOSONGPLAYING",
            infoSongPlaying:
          
            //ID WICHTIG FUER CHEATUEBERWACHUNG
          {
          
          
            "is_playing": false, //wichtig wegen cheating
          
                 "item": {
          
           
          
                "id": "ischeating",  //WICHTIG FUER CHEATUEBERWACHUNG
                "name": "check is cheating",
          
                }
          },
          
          
          }) //song cheating chekck zu ausgangslage ende
          

          //CHEATCHECK SONG ZU AUSGANGSLAGE ENDE



          
          dispatch({
            type: "SET_PLAYBLOCKER",
            playBlocker: null,

          })

          dispatch({
            type: "SET_DBLESENCOMINGMENU",
            dblesencomingfrommenu:1,
          });



          dispatch({
            type: "SET_SHOWBUTTONBACKTOCAROUSEL",
            showButtonBackToCarousel: 1,
    
          });

 // song to add zurück setzen
 dispatch({
  type: "SET_SONGTOADDCHOSEN",
  songToAddChosen: 0,
    });

 // reset user ratings count
 dispatch({
  type: "SET_COUNTUSERRATINGS",
  countUserRatings: 0,
    });


// ERSTES MAL slide ist auf 1


// -> Passiert nicht beim 1ten mal
   if (slideNrToShowToUser===2) {

    dispatch({
      type: "SET_SLIDENRTOSHOWTOUSER",
      slideNrToShowToUser: 3,
 
     });

    };
// -> Passiert beim 1ten mal

if (slideNrToShowToUser===1) {

    dispatch({
      type: "SET_SLIDENRTOSHOWTOUSER",
      slideNrToShowToUser: 2,
 
     });

    };


    
        
    //LADEN DER SONG HINZUFÜGEN MASKE, WENN GENUG SONGS GERATED
   //ChooseSong.js wird geladen
      dispatch({
        type: "SET_MENUSTATE",
        menustate: "feedbackcarouselmenu",
      });

 //   token && menustate==="feedbackcarouselmenu" && <FeedbackCarousel spotify={spotify}/>



}, [dispatch, slideNrToShowToUser]);

// Bei jedem counter change
useEffect(() => {
  // Only count down and redirect if this is NOT a limited songs upload
  if (!shouldShowNoMoreSongs) {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);

    //passiert jede sekunde bis zeit abgelaufen

    // automatisch zurück wenn User etwas abspielt!!!
    if (counter === 0) {
      // console.log("User is currently playing something!");
      backToCarousel();
    }
  }
}, [counter, backToCarousel, shouldShowNoMoreSongs]);
  return (


    <div className="body">



      <div className="song__thatWillBeAdded">
        {shouldShowNoMoreSongs ? (
          // Show "No more songs to rate" message for limited songs uploads
          <>
            <h1><span role="img" aria-label="check">✅</span> Song Added Successfully!</h1>
            <p>&nbsp;</p>
            <h2 style={{fontSize: '24px', marginBottom: '30px', color: '#333'}}>
              No More Songs to Rate
            </h2>
            <p style={{fontSize: '18px', color: '#666', lineHeight: '1.6'}}>
              Please come back later for more songs to rate.
            </p>
            <p style={{fontSize: '14px', color: '#999', marginTop: '40px'}}>
              Your song "{NameOfAddedSong}" has been successfully added to the carousel!
            </p>
            <div style={{ marginTop: '40px' }}>
              <button
                onClick={handleLogout}
                style={{
                  padding: '12px 30px',
                  backgroundColor: '#fff',
                  color: '#333',
                  border: '2px solid #ddd',
                  borderRadius: '25px',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  display: 'inline-block',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f5f5f5';
                  e.target.style.borderColor = '#999';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#fff';
                  e.target.style.borderColor = '#ddd';
                }}
              >
                Logout
              </button>
            </div>
          </>
        ) : (
          // Show regular success message with button to continue
          <>
            <h1>Success<span role="img" aria-label="party">🎉</span>! Your song: "{NameOfAddedSong}" is added!</h1>
            <p>&nbsp;</p>

            {showButtonBackToCarousel===1 &&
              <div className="takeMeBack" onClick={backToCarousel} >
                <h2><button type="button">Take me to the Song Carousel so I can play and rate more songs</button></h2>
              </div>
            }
          </>
        )}
            </div>





    </div>
  );
}

export default MeldungSongGeAddedBody;
